/* VANIL A BEAN — mobile "Read the label" scene (#x-ingredients .rvx-mob).
   Lives outside the product liquid, which had reached its 262,144-byte ceiling.
   Ships BOTH the CSS and the behaviour, so there is exactly one file to upload.
   The liquid hides .ximo by default and this script reveals it — so if this file
   is ever missing, the scene is simply absent and the page is otherwise intact,
   rather than rendering as unstyled stacked beats over a dead canvas.
   Desktop never runs any of it: the guard returns above 899px, and every rule is
   inside one @media(max-width:899px) block scoped to #x-ingredients. */
(function () {
  try {
    if (window.innerWidth >= 900) return;

    /* ONE LEFT EDGE (2026-09-26). Every line of text on the mobile page starts on
       the same vertical: the 6.5% gutter the scroll scenes use (24-25px on a
       phone, the same as the 24px sections to within a pixel). Audited by
       measuring the first glyph of every visible text node; these were the
       sections off that line, and by how much:
         Thomas quote        28px (padding 28)       -> 6.5%
         Journey captions    23px (left 6vw)         -> 6.5%
         Farmers caption     35px (centred, 320 box) -> 6.5%, left-aligned
         Final section       31px (padding 8vw)      -> 6.5%
         Buy panel           21px (padding 20)       -> 6.5%
       (Why It's Different was 49px - fixed at its source in
       vab-mobile-compounds.js; Daily Ritual's copy was 56px - fixed in
       vab-ritual-canvas.js.) Button labels and the two-option scroll cue under
       the pour stay centred: they are controls, not copy. Injected here because
       this file loads first on every mobile page view; prefixed html body with
       !important because each rule it replaces is !important in the liquid. */
    (function () {
      var g = document.createElement('style');
      g.textContent = '@media(max-width:899px){' +
        'html body .s-thomas{padding-left:6.5%!important;padding-right:6.5%!important}' +
        'html body #x-journey .vjxm-caps{left:6.5%!important;right:6.5%!important}' +
        'html body #x-origin .xo-film-cap{left:6.5%!important;right:6.5%!important;width:auto!important;transform:none!important;text-align:left!important}' +
        'html body #x-origin .xo-film-cap .vjx-h{text-align:left!important}' +
        'html body .s-final{padding-left:6.5%!important;padding-right:6.5%!important}' +
        'html body .vab-pur-panel{padding-left:6.5%!important;padding-right:6.5%!important}' +
        '}';
      document.head.appendChild(g);
    })();

    /* THE APERTURE (2026-09-27, v3 - buttery). Both films - the journey after the
       pour, and Farmers after Tasting Notes - arrive as a framed card that opens to
       full bleed, and close back into a card as they leave.
       v2 did it with a position:fixed stage and a clip-path whose edges followed the
       section's rect in JS. On an iPhone the page scrolls on the compositor and JS
       runs a frame or two behind it, irregularly - so an edge that JS has to place
       to match the scroll can never be exact, and it jittered.
       v3 moves nothing in JS. The film stays in the page and scrolls natively, so
       its edges are the browser's own and cannot lag. JS only changes the card's
       SHAPE - the side gutters, the corner radius and the picture's slight
       push-back - none of which has to line up with anything, and it eases them
       with the same 0.12-per-frame smoothing every scene on the page uses, so even
       a dropped frame reads as easing rather than a step. No position:fixed, no
       masks, no opacity on the picture. The caption appears once the frame is open.
       Mobile only; with reduced motion the films are plain full-bleed sections. */
    (function () {
      if (window.innerWidth >= 900) return;
      if (window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches) return;
      var c = document.createElement('style');
      c.textContent = '@media(max-width:899px){' +
        'html body .vap-card{will-change:clip-path;-webkit-mask-image:none!important;mask-image:none!important}' +
        'html body .vap-card .vap-media{will-change:transform;transform-origin:50% 50%}' +
        /* the journey card shows its picture from the first pixel - no fade-up inside the frame */
        'html body #x-journey #vjxm-wrap{background:#0B0A08!important}' +
        'html body #x-journey .vjxm-video{opacity:1!important;transition:none!important}' +
        /* FARMERS CAPTION (2026-10-01). Its words were swept in by viewport position,
           a sweep that only finished near the top of the screen - so with the film
           full frame the line sat a third lit, and it never read. The words are now
           simply there in full, and the line itself arrives with the frame (below). */
        'html:root body #x-origin .xo-film-cap .vwr-ch{color:#F5F1EA!important;transition:none!important}' +
        /* the pour is never erased to paper */
        'html:root body #x-pour .x-pour-veil{opacity:0!important;display:none!important}' +
        '}';
      document.head.appendChild(c);
      var cl = function (x) { return x < 0 ? 0 : x > 1 ? 1 : x; };
      var ss = function (x) { return x * x * (3 - 2 * x); };
      var G = 0.065, RAD = 40, OPEN = 0.7, EASE = 0.12;
      function make(sec, card, media, caps) {
        if (!sec || !card) return null;
        media = (media || []).filter(Boolean);
        card.classList.add('vap-card');
        media.forEach(function (m) { m.classList.add('vap-media'); });
        var st = { k: -1, clip: '', tf: '', co: -1 };
        /* 0 = card, 1 = full bleed, from where the section sits */
        function target(vh) {
          var r = sec.getBoundingClientRect();
          if (r.bottom < -vh * 0.2 || r.top > vh * 1.2) return null;         /* well off screen */
          var kin = ss(cl((vh * OPEN - r.top) / (vh * OPEN)));
          var kout = ss(cl((r.bottom - vh * (1 - OPEN)) / (vh * OPEN)));
          return r.top > 0 ? kin : kout;
        }
        function apply(k) {
          var vw = window.innerWidth || 1;
          var g = Math.round(vw * G * (1 - k) * 10) / 10, rad = Math.round(RAD * (1 - k) * 10) / 10;
          var clip = k > 0.999 ? 'none' : 'inset(0px ' + g + 'px 0px ' + g + 'px round ' + rad + 'px)';
          if (clip !== st.clip) { st.clip = clip; card.style.webkitClipPath = clip; card.style.clipPath = clip; }
          var tf = 'scale(' + (1 + 0.08 * (1 - k)).toFixed(4) + ')';
          if (tf !== st.tf) { st.tf = tf; media.forEach(function (m) { m.style.transform = tf; }); }
          if (caps) {
            var co = Math.round(ss(cl((k - 0.72) / 0.28)) * 100) / 100;
            if (co !== st.co) { st.co = co; caps.style.opacity = co; caps.style.translate = '0 ' + ((1 - co) * 14).toFixed(1) + 'px'; }
          }
        }
        /* returns true while still easing */
        function step(vh, snapNow) {
          var t = target(vh);
          if (t === null) { if (st.k !== 0) { st.k = 0; apply(0); } return false; }
          if (st.k < 0 || snapNow) st.k = t;
          else st.k += (t - st.k) * EASE;
          if (Math.abs(t - st.k) < 0.0015) st.k = t;
          apply(st.k);
          return st.k !== t;
        }
        return { step: step };
      }
      /* THE POUR HANDS OVER (2026-09-27). The pour used to end by dissolving to
         bare paper (its veil fades up over the last 14% of the pin), then a blank
         screen scrolled away before the film card rose. With the film arriving as a
         card, a dissolve reads as a gap. Now the scene is never erased: the veil is
         off (CSS below), the pour leaves the screen whole, scrolling natively, and
         the film card rises right behind it - no empty frame between them. As it
         goes, the scene recedes a little (scale 1 -> 0.93, the words leaving a
         beat before the bottle), eased with the page's 0.12 smoothing. Only its
         size changes in JS, never its position, so it cannot jitter. */
      var pour = document.getElementById('x-pour');
      var pText = pour && pour.querySelector('.x-pour-text'), pVis = pour && pour.querySelector('.x-pour-visual');
      var pourStep = null;
      if (pour && (pText || pVis)) {
        [pText, pVis].forEach(function (e) { if (e) { e.style.transformOrigin = '50% 30%'; e.classList.add('vap-media'); } });
        var pk = -1, pT = '', pV = '';
        pourStep = function (vh, now) {
          var r = pour.getBoundingClientRect();
          var t = (r.bottom > vh * 1.05 || r.bottom < -vh * 0.2) ? (r.bottom > vh ? 0 : 1) : ss(cl((vh - r.bottom) / (vh * 0.85)));
          if (pk < 0 || now) pk = t; else pk += (t - pk) * EASE;
          if (Math.abs(t - pk) < 0.0015) pk = t;
          var et = ss(cl(pk / 0.8)), ev = pk;
          var T = 'translate3d(0,' + (-28 * et).toFixed(1) + 'px,0) scale(' + (1 - 0.07 * et).toFixed(4) + ')';
          var V = 'scale(' + (1 - 0.07 * ev).toFixed(4) + ')';
          if (pText && T !== pT) { pT = T; pText.style.transform = T; }
          if (pVis && V !== pV) { pV = V; pVis.style.transform = V; }
          return pk !== t;
        };
      }
      var list = [];
      if (pourStep) list.push({ step: pourStep });
      var js = document.getElementById('x-journey');
      list.push(make(js, js && js.querySelector('.vab-doc-stage'),
        [document.getElementById('vjxm-video'), document.getElementById('vjxm-tint')], document.getElementById('vjxm-caps')));
      /* Farmers: the film and its shade scale together; the caption stays on the frame */
      var og = document.getElementById('x-origin'), film = og && og.querySelector('.xo-film');
      list.push(make(og, film, film ? [film.querySelector('.xo-film-v'), film.querySelector('.xo-film-tint')] : [],
        film && film.querySelector('.xo-film-cap')));
      list = list.filter(Boolean);
      var running = false;
      function loop() {
        var vh = window.innerHeight || 1, busy = false;
        for (var i = 0; i < list.length; i++) if (list[i].step(vh, false)) busy = true;
        if (busy) requestAnimationFrame(loop); else running = false;
      }
      function kick() { if (!running) { running = true; requestAnimationFrame(loop); } }
      window.addEventListener('scroll', kick, { passive: true });
      window.addEventListener('resize', kick, { passive: true });
      requestAnimationFrame(function () { var vh = window.innerHeight || 1; for (var i = 0; i < list.length; i++) list[i].step(vh, true); });
      window.VAB_APERTURE = { render: kick };

      /* DIRECTOR'S MARKS FOR THE FILMS (2026-09-27). The aperture is tied to the
         thumb, so a flick could stop it anywhere - a half-open card is not a frame.
         Same rule as the two locks: when the scroll comes to rest inside a film's
         passage, it glides (0.45-1s, power2.inOut) on to the next composed frame in
         the direction of travel - the film full screen, or the page after it - and a
         nudge under 56px settles back. Journey: [arriving, full frame, gone].
         Farmers: full frame is already Lock 1's last mark, so only [full, gone]. */
      function marks(sec, list2, after) {
        if (!sec || !window.ScrollTrigger) return;
        var y0 = function () { return sec.getBoundingClientRect().top + (window.scrollY || window.pageYOffset || 0); };
        ScrollTrigger.create({
          trigger: sec, start: list2[0] === 'arrive' ? 'top bottom' : 'top top', end: 'bottom top',
          invalidateOnRefresh: true, refreshPriority: -3,
          snap: {
            snapTo: function (v, self) {
              var vh = window.innerHeight, t = y0(), ys = [];
              for (var i = 0; i < list2.length; i++) ys.push(list2[i] === 'arrive' ? t - vh : list2[i] === 'full' ? t : t + sec.offsetHeight - (after ? after() : 0));
              var D = self.end - self.start; if (!(D > 0)) return v;
              var cur = self.scroll(), dir = self.direction || 1, ahead = null, behind = null;
              for (var j = 0; j < ys.length; j++) {
                if (dir > 0) { if (ys[j] > cur + 1 && ahead === null) ahead = ys[j]; if (ys[j] <= cur + 1) behind = ys[j]; }
                else { if (ys[j] < cur - 1) ahead = ys[j]; if (ys[j] >= cur - 1 && behind === null) behind = ys[j]; }
              }
              var dest = ahead;
              if (behind !== null && Math.abs(cur - behind) < 56) dest = behind;
              if (dest === null) dest = behind === null ? cur : behind;
              return cl((dest - self.start) / D);
            },
            duration: { min: 0.45, max: 1.0 }, delay: 0.1, ease: 'power2.inOut', inertia: false
          }
        });
      }
      /* After the journey, the frame is Thomas with its eyebrow on the page's top
         line (just under the pill), not Thomas's top edge at the top of the glass -
         that would park the eyebrow under the pill. */
      function thomasLine() {
        var pill = document.getElementById('vab-anav'), c = 0;
        /* layout box, not the rect: the pill is slid away until Thomas is reached */
        if (pill && pill.offsetHeight > 4) c = pill.offsetTop + pill.offsetHeight;
        c = Math.max(c, 104);                            /* the pill with its tab row, as it stands on Thomas */
        return Math.max(0, c + 26 - 64);                 /* 64 = Thomas's top padding */
      }
      try { marks(js, ['arrive', 'full', 'gone'], thomasLine); marks(og, ['full', 'gone']); } catch (e) {}
    })();

    /* ONE PAPER, ONE TYPE SCALE (2026-09-26). The page-wide polish pass, mobile only.
       1. Type. Four sizes do all the work: 11px labels (one tracking, .26em),
          15px reading text, 32px section headlines, and the scene-scale display
          lines that were already right. Nothing on the page is set below 11px.
          Out of scope on purpose: the pour hero and its facts, the label close-up,
          the purchase panel and the pill - they are tuned instruments.
       2. Paper. The journey, Thomas and the extract photograph sat on a slightly
          cooler cream (#EDEAE0) than the rest of the page (#EAE3D6), a seam you
          felt at every hand-off. Now one sheet.
       3. Farmers becomes a full-screen moment (its entrance and exit are the
          aperture, above).
       4. Reviews: one letter per screen, set large enough to read.
       5. FAQ and the closing line inherit the same scale. */
    (function () {
      var g = document.createElement('style');
      var EY = ['.xsp-eyebrow', '.ximo-ey', '.xcm-eyebrow', '.xcm-index-eyebrow', '.x-tr2-kicker',
                '.xsb-eyebrow', '.xrm-eyebrow', '.sf-ey', '.th-pre', '.rvx-ey', '.xrc-ey', '.xrc-eyebrow']
               .map(function (c) { return 'html body .vab-pdp ' + c + ',html body ' + c; }).join(',');
      g.textContent = '@media(max-width:899px){' +
        /* 1 - type */
        EY + '{font-size:11px!important;letter-spacing:.26em!important}' +
        'html body .xrc-clock,html body .xrc-time,html body .xsb-num,html body .xsb-cta-label{font-size:11px!important}' +
        'html body .faq-h,html body .vab-pdp .faq-h,html body .sf-h,html body .vab-pdp .sf-h{font-size:32px!important;line-height:1.02!important;letter-spacing:-.03em!important}' +
        'html body #x-origin .xo-film-cap .vjx-h{font-size:32px!important;line-height:1.04!important;letter-spacing:-.03em!important}' +
        'html body .xsp-detail,html body .xsb-sub,html body .vjxm-cap-b,html body .sf-sub,html body .xrc-how{font-size:15px!important;line-height:1.5!important}' +
        'html body .faq-q,html body .vab-pdp .faq-q{font-size:16px!important;padding:18px 0!important}' +
        'html body .faq-a,html body .vab-pdp .faq-a{font-size:15px!important;line-height:1.55!important}' +
        /* 2 - one paper */
        'html body #x-journey,html body #x-journey .vjxm-wrap,html body #vjxm-intro,html body #vjxm-outro,html body .s-thomas,html body #x-exhero{--cream:#EAE3D6;background-color:#EAE3D6!important}' +
        /* 3 - Farmers, full screen, warm */
        'html body #x-origin .xo-film{height:100vh!important;height:100svh!important}' +
        /* The warm duotone was tried (2026-09-26) and read as muddy on the faces.
           Back to the film as shot: clean black and white, a touch of contrast,
           a neutral shade only where the caption sits. */
        'html body #x-origin .xo-film-v{filter:grayscale(1) contrast(1.08)}' +
        'html body #x-origin .xo-film-tint{background:linear-gradient(180deg,rgba(10,9,8,0) 0%,rgba(10,9,8,0) 48%,rgba(10,9,8,.42) 76%,rgba(10,9,8,.56) 100%)!important}' +
        'html body #x-origin .xo-film-cap{bottom:20%!important}' +
        'html body #x-origin .xo-film-cap .vjx-h{color:#F5F1EA!important;text-shadow:0 2px 18px rgba(0,0,0,.35)!important}' +
        /* 4 - reviews: one letter per screen */
        'html body .xrm-eyebrow,html body .xrm-head{padding-left:6.5%!important;padding-right:6.5%!important}' +
        'html body .xrm-scroll{scroll-padding-left:6.5vw;margin-top:32px!important}' +
        'html body .xrm-track{gap:14px!important;padding:0 13.5vw 8px 6.5vw!important}' +
        'html body .xrm-card{flex:0 0 80vw!important;width:80vw!important}' +
        'html body .xrm-inner{padding:10% 9% 8%!important}' +
        'html body .xrm-mark{font-size:11px!important;padding:8px 12px!important}' +
        'html body .xrm-quote{font-size:clamp(18px,5.4vw,22px)!important;line-height:1.34!important;margin-bottom:12px!important}' +
        'html body .xrm-body{font-size:14px!important;line-height:1.55!important}' +
        'html body .xrm-meta{font-size:11px!important;letter-spacing:.1em!important;margin-top:24px!important}' +
        /* 6 - full frame (2026-09-27): the driftwood photograph fills the screen
           instead of stopping at its 2:3 box with paper beneath it. Cropped from
           the left so the bottle, at the right of the frame, stays whole. */
        'html body #x-exhero picture{height:100vh!important;height:100svh!important}' +
        'html body #x-exhero img{height:100%!important;aspect-ratio:auto!important;object-fit:cover!important;object-position:78% 50%!important}' +
        /* Read the Label: the bottle gets the room the split was holding back */
        'html body #x-ingredients .ximo-bottle,html body #x-sensory .ximo-bottle{padding-bottom:18px!important}' +
        /* 5 - FAQ + close */
        'html body .s-faq{padding-left:6.5%!important;padding-right:6.5%!important}' +
        '}';
      document.head.appendChild(g);
    })();

    /* ONE SCREEN, EDGE TO EDGE (2026-09-27, v2). The rule: every full-screen scene
       fills the whole glass, whatever Safari's toolbar is doing.
       v1 sized the stages to 100lvh. Two things beat it, both found by measuring:
         1. GSAP writes the pinned stage's measured height into BOTH height and
            max-height, inline - so a stylesheet height alone never takes over.
         2. Safari now draws the page under its floating toolbar, so the large
            viewport still stops at the top of the bar and the bar showed bare
            paper beneath it.
       So the stage is now the height of the SCREEN itself (portrait: the device's
       long edge, which is always at least the tallest the viewport can be), set
       from JS as --vab-sh, with max-height released. Whatever the toolbar does, the
       scene runs under it to the bottom of the glass.
       Everything that sits on the floor is lifted by --vab-lift = stage minus the
       SAFE viewport (svh, the height with the toolbar up), so copy, cards,
       captions and the ritual's spine always sit 26px above the toolbar and
       never move when it comes and goes. Things placed as a share of the screen
       (the Why It's Different count, Subscribe's bottle box) use --vab-svh. */
    (function () {
      var root = document.documentElement;
      /* EDGE TO EDGE (2026-09-27, v3). Without viewport-fit=cover, iOS Safari keeps
         the page out of the strip behind its floating toolbar and the home
         indicator, and paints that strip itself - which is why the scenes could
         never reach the true bottom whatever height they were given. The theme's
         viewport tag is extended here, mobile only; every floor on the page already
         adds env(safe-area-inset-bottom), so nothing sinks under the home bar. */
      if (window.innerWidth < 900) {
        var vp = document.querySelector('meta[name="viewport"]');
        if (!vp) { vp = document.createElement('meta'); vp.name = 'viewport'; vp.content = 'width=device-width,initial-scale=1'; document.head.appendChild(vp); }
        if (!/viewport-fit\s*=\s*cover/.test(vp.content || '')) vp.content = (vp.content ? vp.content + ',' : '') + 'viewport-fit=cover';
      }
      function probe(h) {
        var p = document.createElement('div');
        p.style.cssText = 'position:absolute;visibility:hidden;pointer-events:none;top:0;left:0;width:1px;height:100vh;height:' + h;
        document.body.appendChild(p); var v = p.offsetHeight; p.remove(); return v;
      }
      var lastW = -1;
      function measure() {
        var w = window.innerWidth; if (w === lastW) return; lastW = w;
        var svh = probe('100svh') || window.innerHeight;
        var lvh = probe('100lvh') || probe('100vh') || window.innerHeight;
        var portrait = window.innerHeight >= window.innerWidth;
        var scr = portrait ? Math.max(screen.width || 0, screen.height || 0) : 0;
        var sh = Math.max(lvh, svh, scr);
        root.style.setProperty('--vab-sh', sh + 'px');
        root.style.setProperty('--vab-svh', svh + 'px');
        window.VAB_SCREEN = { sh: sh, svh: svh, lvh: lvh };
        lastLift = -1; follow();
      }
      /* THE FLOOR FOLLOWS THE GLASS (2026-10-01). v2 lifted every floor by the
         toolbar's full height ALL the time, so with the toolbar tucked away the
         copy, cards and captions still stood a toolbar's height above the real
         bottom - "it places all elements above the URL space". The lift is now the
         live gap between the stage and the bottom of what is actually visible
         (visualViewport): toolbar up, the floor sits above it; toolbar tucked,
         the floor comes down to the glass. The change eases in step with Safari's
         own toolbar animation (transition below), so nothing jumps. */
      var lastLift = -1, fq = false;
      function follow() {
        fq = false;
        var S = window.VAB_SCREEN; if (!S) return;
        var vv = window.visualViewport;
        var vis = vv ? Math.round(vv.height + vv.offsetTop) : window.innerHeight;
        if (!(vis > 200)) vis = S.svh;
        var lift = Math.max(0, S.sh - Math.max(vis, S.svh));
        if (lift === lastLift) return;
        lastLift = lift; root.style.setProperty('--vab-lift', lift + 'px');
      }
      function followSoon() { if (!fq) { fq = true; requestAnimationFrame(follow); } }
      measure();
      window.addEventListener('resize', function () { measure(); followSoon(); }, { passive: true });
      if (window.visualViewport) {
        window.visualViewport.addEventListener('resize', followSoon, { passive: true });
        window.visualViewport.addEventListener('scroll', followSoon, { passive: true });
      }
      window.addEventListener('scroll', followSoon, { passive: true });
      window.addEventListener('orientationchange', function () { lastW = -1; setTimeout(measure, 250); }, { passive: true });

      var R = 'html:root body ';
      var LIFT = 'var(--vab-lift,0px)';
      var FLOOR = 'calc(env(safe-area-inset-bottom,0px) + 26px + ' + LIFT + ')';
      var g = document.createElement('style');
      g.textContent = '@media(max-width:899px){' +
        /* stages: the whole glass */
        R + '#xsp .xsp-stage,' + R + '.xsp-stage,' +
        R + '#x-ritual .xrc-stage,' +
        R + '#x-trace .xtr-pin,' + R + '#x-ritual .xtr-pin.xtr-merged,' +
        R + '#x-ingredients .ximo-pin,' + R + '#x-sensory .ximo-pin.ximo-merged,' +
        R + '#x-subscribe .xsb-stage,' +
        R + '#x-journey .vab-doc-stage,' +
        R + '#x-origin .xo-film,' + R + '#x-exhero picture' +
          '{height:var(--vab-sh,100lvh)!important;max-height:none!important}' +
        /* Thomas follows the film directly (2026-09-27): it was a full screen with its
           words pushed to the floor (flex-end, plus a 20vh shove), so as the film card
           closed and left, most of a screen of empty paper followed it. The words
           now start just under the film and the section ends where they do. */
        R + '.s-thomas{min-height:0!important;justify-content:flex-start!important;' +
          'padding-top:64px!important;padding-bottom:28px!important}' +
        R + '.s-thomas .th-q{margin-bottom:0!important}' +
        R + '.s-thomas .th-block{transform:none!important}' +
        /* floors: lifted clear of the toolbar */
        R + '#xsp .xsp-focus{bottom:' + FLOOR + '!important}' +
        R + '.ximo-copy{padding-bottom:' + FLOOR + '!important}' +
        R + '#x-trace .xtr-pin,' + R + '#x-ritual .xtr-pin.xtr-merged{padding-bottom:' + FLOOR + '!important}' +
        R + '#x-ritual .xrc-copy,' + R + '#x-ritual .xrc-statement.xrc-close,' + R + '#x-ritual .xrc-spine{bottom:' + FLOOR + '!important}' +
        R + '#x-subscribe .xsb-copy{bottom:calc(env(safe-area-inset-bottom,0px) + 28px + ' + LIFT + ')!important;' +
          'top:calc(var(--xsb-clear,96px) + 34px + var(--vab-svh,100svh) * .42)!important}' +
        R + '#x-subscribe .xsb-subject{height:calc(var(--vab-svh,100svh) * .42)!important}' +
        R + '#x-sensory .xcm-count{top:calc(var(--vab-svh,100svh) * .47)!important}' +
        R + '#x-journey .vjxm-caps{bottom:calc(8svh + env(safe-area-inset-bottom,0px) + ' + LIFT + ')!important}' +
        R + '#x-origin .xo-film-cap{bottom:calc(20svh + ' + LIFT + ')!important}' +
        /* the ritual's dish box stays the safe screen, so the dish rests where it did */
        R + '#x-ritual .xrc-specimen{bottom:' + LIFT + '!important}' +
        /* floors ease with the toolbar rather than jumping when it moves */
        R + '#xsp .xsp-focus,' + R + '#x-ritual .xrc-copy,' + R + '#x-ritual .xrc-statement.xrc-close,' + R + '#x-ritual .xrc-spine,' +
          R + '#x-subscribe .xsb-copy,' + R + '#x-journey .vjxm-caps,' + R + '#x-origin .xo-film-cap,' + R + '#x-ritual .xrc-specimen' +
          '{transition-property:bottom;transition-duration:.34s;transition-timing-function:cubic-bezier(.2,.7,.2,1)}' +
        R + '.ximo-copy,' + R + '#x-trace .xtr-pin,' + R + '#x-ritual .xtr-pin.xtr-merged' +
          '{transition-property:padding-bottom;transition-duration:.34s;transition-timing-function:cubic-bezier(.2,.7,.2,1)}' +
        '}';
      document.head.appendChild(g);
      /* ON-DEVICE READOUT: add ?vabvh=1 to the URL to see the numbers this rule is
         working from, live, in the corner of the screen (for a screenshot). */
      if (/[?&]vabvh=1/.test(location.search)) {
        var dbg = document.createElement('div');
        dbg.style.cssText = 'position:fixed;left:6px;bottom:calc(env(safe-area-inset-bottom,0px) + 6px);z-index:2147483647;' +
          'font:10px/1.35 ui-monospace,Menlo,monospace;background:rgba(0,0,0,.72);color:#fff;padding:6px 8px;border-radius:6px;pointer-events:none;white-space:pre';
        document.body.appendChild(dbg);
        var sib = function (x) { var e = document.createElement('div'); e.style.cssText = 'position:absolute;visibility:hidden;height:env(safe-area-inset-' + x + ',0px)'; document.body.appendChild(e); var h = e.offsetHeight; e.remove(); return h; };
        var tickD = function () {
          var S = window.VAB_SCREEN || {}, vv = window.visualViewport;
          var st = document.querySelector('.vab-pin-active, #xsp-stage, #xrcStage');
          var sr = st ? st.getBoundingClientRect() : null;
          dbg.textContent = 'inner ' + window.innerWidth + 'x' + window.innerHeight + '  vv ' + (vv ? Math.round(vv.height) : '-') +
            '\nsvh ' + S.svh + '  lvh ' + S.lvh + '  scr ' + screen.width + 'x' + screen.height +
            '\nstage ' + S.sh + '  lift ' + getComputedStyle(root).getPropertyValue('--vab-lift') +
            '\nsafe-b ' + sib('bottom') + '  safe-t ' + sib('top') +
            (sr ? '\nxsp/xrc stage top ' + Math.round(sr.top) + ' bottom ' + Math.round(sr.bottom) : '') +
            '\nvp ' + ((document.querySelector('meta[name=viewport]') || {}).content || '');
          requestAnimationFrame(tickD);
        };
        tickD();
      }
      /* the safe (toolbar-up) height in px, for the scenes that compose in JS */
      window.VAB_SAFE_H = function () { return (window.VAB_SCREEN && window.VAB_SCREEN.svh) || probe('100svh') || window.innerHeight; };
    })();

    /* ---------------------------------------------------------------- styles
       Type mirrors the desktop scene family-for-family. Desktop values, at a
       1440px viewport, are noted against each so the mobile sizes are visibly a
       re-scaling of the same hierarchy rather than a separate set of choices. */
    var CSS = `
@media(max-width:899px){
  /* Every selector below is prefixed with html body. The asset injects this <style>
     into <head>; the product liquid's <style> sits in <body>, LATER in document
     order, so at equal specificity the liquid wins and these rules are silently
     inert on the live theme — which is exactly what happened to the runway trim
     (the section kept running 460svh while this file said 360). The prefix puts
     them out of reach, so uploading this one file is genuinely enough. */
  /* Runway. 360svh, down from 460. Matching desktop's 460vh gave each of the five
     beats 0.94 of a screen — a full phone-height of scrolling to change three words,
     which is what made the page read as a slideshow rather than a scroll. 260svh of
     pinned runway puts a beat at 52svh: still above the ~45svh floor where a thumb
     flick blows past before the line can be read, but no longer a held frame.
     MUST match the height the liquid reserves, or ScrollTrigger measures one page
     and lays out another. */
  html body #x-ingredients .ximo{position:relative;height:360svh}

  /* PINNING. NOT position:sticky — html, body and .vab-pdp all carry
     overflow-x:hidden, which makes each a scroll container and stops sticky ever
     engaging against the viewport. Every other scene on this page pins with JS
     for the same reason. Absolute before, fixed during, absolute after. */
  html body #x-ingredients .ximo-pin{
    position:absolute;top:0;left:0;right:0;
    /* Three declarations, deliberately. An unknown UNIT fails at PARSE time so the
       line above survives — unlike var(), which fails at computed-value time and
       drops the property to auto. That distinction is why the var() attempt took a
       whole section off the page and this one cannot. dvh is the live viewport, so
       the box reaches the real bottom of the screen the moment the URL bar goes.
       The runway is set in svh, so the scroll maths never move. */
    height:100vh;height:100svh;height:100dvh;
    background:#EAE3D6;                  /* it leaves flow when fixed */
    z-index:1;                           /* under the floating pill (9999) */
    display:flex;flex-direction:column;overflow:hidden}
  html body #x-ingredients .ximo-pin.is-fixed{position:fixed;top:0}
  html body #x-ingredients .ximo-pin.is-end{position:absolute;top:auto;bottom:0}

  /* The copy sits ON the floor and the bottle takes everything above it — the same
     rule as the tasting-notes scene. flex:0 1 75% left the bottle zone at exactly
     75% and the copy at its natural height below, so whatever the two did not add
     up to became dead cream under the text. flex:1 1 auto cannot leave a gap: the
     bottle zone absorbs all of it. The bottle does not grow to fill, because the
     canvas is separately capped at 38% of the stage — it just centres in more room.
     --ximo-clear is measured from the live pill, which grows a second row when its
     menu opens. */
  html body #x-ingredients .ximo-bottle{
    flex:1 1 auto;min-height:0;
    padding-top:var(--ximo-clear,202px);
    padding-bottom:40px;                 /* the split: the bottle is height-driven,
                                            so without this it grows until its base
                                            touches the seam */
    display:flex;align-items:center;justify-content:center;box-sizing:border-box}
  html body #x-ingredients .ximo-cv{display:block}

  html body #x-ingredients .ximo-copy{
    position:relative;flex:0 0 auto;margin-top:auto;   /* pinned to the floor */
    padding:24px 6.5vw calc(env(safe-area-inset-bottom,0px) + 26px);
    display:flex;flex-direction:column;box-sizing:border-box}
  html body #x-ingredients .ximo-copy::before{
    content:'';position:absolute;top:0;left:6.5vw;right:6.5vw;height:1px;
    background:linear-gradient(to right,rgba(32,24,15,.20),rgba(32,24,15,.04));
    opacity:0;transition:opacity .6s ease}
  html body #x-ingredients .ximo.seam-on .ximo-copy::before{opacity:1}

  /* ANCHOR — eyebrow + headline, persistent above the beats exactly as on desktop,
     where .rvx-ey and .rvx-head stand while the slides change beneath them. */
  html body #x-ingredients .ximo-ey{                      /* desktop .rvx-ey: sans 500 / 11.5px / .3em */
    font-family:var(--sans);font-weight:500;font-size:10px;letter-spacing:.3em;
    text-transform:uppercase;color:#8A7860;margin:0 0 13px}
  html body #x-ingredients .ximo-head{                    /* desktop .rvx-head: serif 400 / 43px / 1.02 */
    font-family:var(--serif);font-weight:400;font-size:clamp(24px,6.6vw,30px);
    line-height:1.04;letter-spacing:-.03em;color:var(--ink);margin:0 0 20px;
    text-wrap:balance}

  html body #x-ingredients .ximo-beats{position:relative;flex:0 0 auto}
  html body #x-ingredients .ximo-beat{
    position:absolute;top:0;left:0;right:0;opacity:0;
    will-change:opacity,transform;pointer-events:none}
  /* Measuring pass: lay the beats out in flow just long enough to read their
     natural heights, then put them back. Happens before paint. */
  html body #x-ingredients .ximo-beats.ximo-measuring .ximo-beat{
    position:static;opacity:0;transform:none}

  /* The masked line-rise. Each child of an ingredient beat clips its own content
     and the inner span travels up from 100% — same construction as desktop's
     .rvx-rise, including the .12em of descender padding. */
  html body #x-ingredients .ximo-rise{display:block;will-change:transform;padding-bottom:.12em}

  html body #x-ingredients .ximo-lead{                    /* desktop .rvx-lead: SANS 400 / 17.3px / 1.68 */
    font-family:var(--sans);font-weight:400;font-size:16px;line-height:1.66;
    color:var(--ink);margin:0}
  html body #x-ingredients .ximo-n{                       /* desktop .rvx-n: SERIF 400 / 14.4px / gold */
    display:block;font-family:var(--serif);font-weight:400;font-size:13px;
    letter-spacing:.12em;color:var(--gold);margin-bottom:12px}
  html body #x-ingredients .ximo-t{                       /* desktop .rvx-t: serif 400 / 30px / 1.08 */
    display:block;font-family:var(--serif);font-weight:400;
    font-size:clamp(22px,5.9vw,27px);line-height:1.08;letter-spacing:-.02em;
    color:var(--ink);margin-bottom:12px}
  html body #x-ingredients .ximo-d{                       /* desktop .rvx-d: sans 400 / 15px / 1.66 */
    display:block;font-family:var(--sans);font-weight:400;font-size:14.5px;
    line-height:1.64;color:var(--muted)}
  html body #x-ingredients .ximo-fine{                    /* desktop .rvx-fine: SANS 500 / 13px / .14em caps */
    font-family:var(--sans);font-weight:500;font-size:11.5px;letter-spacing:.14em;
    text-transform:uppercase;color:var(--ink);margin:0 0 18px}
  html body #x-ingredients .ximo-bean{display:block;width:74%;max-width:300px;height:auto;margin:0}

  @media(prefers-reduced-motion:reduce){
    html body #x-ingredients .ximo-rise{transform:none!important}
  }
}`;
    var st = document.createElement('style');
    st.textContent = CSS;
    document.head.appendChild(st);

    var host = document.querySelector('#x-ingredients .ximo');

    /* LOCK 1 (2026-09-23). Read the Label no longer pins on its own. Its stage is
       moved INTO the Tasting Notes stage as the opening chapter of one lock:
       Read the Label -> Why it tastes different -> Tasting Notes. Back-to-back pins
       were each a seam - lock, release, slide, lock again. Now the screen locks
       once, the chapters dissolve inside it, and it releases once.
       Nothing is re-timed. #ximo gives up its 360svh and #xsp takes exactly that
       360svh on (vab-sensory.js reads VAB_LEAD1), so the page is the same length
       and every scene has the same scroll distance it had: this chapter's 260svh,
       then the 100svh that used to be the pin sliding away (now the dissolve into
       the compounds), then the Tasting Notes scene exactly as before. The two
       Tasting Notes files see a VIRTUAL geometry shifted by the lead, so they
       behave as if the section were still arriving from below.
       If anything here is missing the page falls back to the old separate scene. */
    var tnStage = document.querySelector('#x-sensory .xsp-stage');
    var pinEl = host && host.querySelector('.ximo-pin');
    if (host && pinEl && tnStage && document.getElementById('xsp')) {
      var LEAD_CSS = '360svh';
      st.textContent = CSS.replace(/#x-ingredients \./g, ':is(#x-ingredients,#x-sensory) .') + `
@media(max-width:899px){
  html body #x-ingredients .ximo{height:0!important;min-height:0!important;overflow:hidden!important}
  /* The chapter has moved into the lock, so the section's 64px of bottom padding
     was all that remained of it - a strip of paper between the photograph and the
     lock. Gone (2026-09-26). */
  html body #x-ingredients .rvx-mob{padding-bottom:0!important}
  /* The chapter as a layer over the Tasting Notes stage. Transparent, so the stage
     underneath is the one sheet of paper; inert, so it never blocks a tap on the
     scenes after it (by then everything in it has faded to nothing). */
  html body #x-sensory .ximo-pin.ximo-merged{position:absolute!important;top:0!important;left:0!important;
    right:0!important;bottom:0!important;height:auto!important;background:transparent!important;
    z-index:8!important;pointer-events:none}
  html body #x-sensory .ximo-pin.ximo-merged.seam-on .ximo-copy::before{opacity:1}
}`;
      tnStage.appendChild(pinEl);
      pinEl.classList.add('ximo-merged');
      var probeCache = null, probeW = window.innerWidth;
      window.VAB_LEAD1 = {
        css: LEAD_CSS,
        px: function () {
          if (window.innerWidth !== probeW) { probeW = window.innerWidth; probeCache = null; }
          if (probeCache == null) {
            var pr = document.createElement('div');
            pr.style.cssText = 'position:absolute;visibility:hidden;pointer-events:none;top:0;left:0;width:1px;height:' + LEAD_CSS;
            document.body.appendChild(pr); probeCache = pr.offsetHeight || 0; pr.remove();
          }
          return probeCache;
        }
      };
      document.documentElement.classList.add('vab-lock1');

      /* The pill's section tabs light from which section crosses mid-screen, and
         their taps scroll to that section's top. With Read the Label folded into
         this lock, #x-ingredients has no height, and "Why It's Different" pointed
         at #x-compounds, which does not display on mobile at all (its tap scrolled
         to the top of the page). Three markers inside the lock now stand in for
         the three chapters, so the right tab lights and each tap lands on its own
         chapter. Boundaries sit mid-handover (the 50% reference line):
           Ingredients    0            -> 360svh
           Why            360svh       -> +143.6vh   (preface .26 x 360vh runway + 50vh)
           Tasting Notes  the rest */
      var xspEl = document.getElementById('xsp');
      var mk = function (id, top, h) {
        var d = document.createElement('div'); d.id = id; d.setAttribute('aria-hidden', 'true');
        d.style.cssText = 'position:absolute;left:0;width:1px;pointer-events:none;visibility:hidden;top:' + top + ';' + (h ? 'height:' + h : 'bottom:0');
        xspEl.appendChild(d);
      };
      mk('vab-mk-ing', '0px', '360svh');
      mk('vab-mk-why', '360svh', '143.6vh');
      mk('vab-mk-tn', 'calc(360svh + 143.6vh)', '');
      (window.vabPageSections || []).forEach(function (s) {
        if (s.sel === '#x-ingredients') s.sel = '#vab-mk-ing';
        else if (s.sel === '#x-compounds') s.sel = '#vab-mk-why';
        else if (s.sel === '#x-sensory') s.sel = '#vab-mk-tn';
      });
    }
    if (host) host.classList.add('ximo-go');
    /* Layout is stable before this runs — the liquid reserves the runway — but any
       trigger that measured early still gets a chance to re-read the page. */
    if (window.ScrollTrigger && ScrollTrigger.refresh) {
      requestAnimationFrame(function () { try { (window.vjxSafeRefresh || ScrollTrigger.refresh)(); } catch (e) {} });
    }
  } catch (e) {}
})();

/* ------------------------------------------------------------------ behaviour
   Choreography mirrors the desktop turntable: the bottle scatters in from the
   moment the stage pins, settles, turns through the three ingredients, and is
   home to label-front exactly as "That's the entire recipe" lands. The turn is
   the index, not decoration. */
(function () {
  try {
    if (window.innerWidth >= 900) return;
    var sec = document.getElementById('x-ingredients'); if (!sec) return;
    var run = document.getElementById('ximo'); if (!run) return;
    var pin = document.querySelector('.ximo-pin'); if (!pin) return;
    /* LOCK 1: the stage now lives inside the Tasting Notes stage (see above). */
    var LEAD = window.VAB_LEAD1 || null;
    var geo = LEAD ? (document.getElementById('xsp') || run) : run;
    var cv = document.getElementById('ximo-cv'); if (!cv) return;
    var ctx = cv.getContext('2d'); if (!ctx) return;
    var beats = [].slice.call(pin.querySelectorAll('.ximo-beat'));
    if (!beats.length) return;
    var anchor = [].slice.call(pin.querySelectorAll('.ximo-ey,.ximo-head'));

    /* Same sheet as the desktop scene: 9x8 grid, 71 unique frames, mirrored for
       the return. N must stay 2*UNIQ or the mirror runs off the sheet. */
    var COLS = 9, N = 142, UNIQ = 71, FW = 288, FH = 499, AR = FW / FH, F0 = 0;
    var img = new Image(), ready = false;
    img.crossOrigin = 'anonymous';
    img.onload = function () { ready = true; fit(); draw(last, lastAsm); };
    img.src = cv.getAttribute('data-sprite') || '';

    var cl = function (x) { return x < 0 ? 0 : x > 1 ? 1 : x; };
    /* Desktop's two easings, copied rather than approximated. */
    function eOut(t) { return 1 - Math.pow(1 - t, 3); }
    function eIn(t) { return t * t * t; }

    var dpr = Math.min(window.devicePixelRatio || 1, 2.5);
    var zone = pin.querySelector('.ximo-bottle');
    var beatsBox = pin.querySelector('.ximo-beats');

    /* Five beats; the headline is persistent above them, so the closing frame
       reads "Read the label. / If it needs explaining, it probably doesn't
       belong. / That's the entire recipe." with the bean — as on desktop. */
    var B = [[0.030, 0.220], [0.220, 0.410], [0.410, 0.600], [0.600, 0.790], [0.790, 0.975]];
    /* DIRECTOR'S MARKS (2026-09-24). The composed frames of this chapter, in its own
       progress: the bottle under the headline at lock; the lead line held; each
       ingredient fully risen (lp .60, before its exit at .72); and the finale at
       lp .30 - fully in, just before the bottle begins to dissolve (DIS_S). The
       Lock 1 director in vab-sensory.js glides the page to these when it comes to
       rest. Derived from B so a retime moves the marks with it. */
    if (window.VAB_LEAD1) window.VAB_LEAD1.marks = [
      0,
      B[0][0] + 0.50 * (B[0][1] - B[0][0]),
      B[1][0] + 0.60 * (B[1][1] - B[1][0]),
      B[2][0] + 0.60 * (B[2][1] - B[2][0]),
      B[3][0] + 0.60 * (B[3][1] - B[3][0]),
      Math.min(B[4][0] + 0.30 * (B[4][1] - B[4][0]), B[4][0] + 0.055)
    ];
    var ASM_S = 0, ASM_E = 0.160;   /* the pinned fallback, kept for reduced-motion
                                       and for any frame that runs before a rect */
    /* APPROACH WINDOW. The assembly used to begin at pinned p=0 — i.e. the instant
       the stage locked, by which point the section is already the whole screen, so
       the bottle materialised into a frame that had finished arriving. This is the
       same mistake the bean entrance made, and the same fix: build against how far
       the section has RISEN, not against its pinned progress. 0 when the top edge
       is 85% down the viewport, solid at 92% risen — before the lock. The scene
       therefore lands complete rather than starting there, and the scroll that used
       to be an empty section climbing the screen now carries the entrance.
       ARR_T is the type, deliberately trailing the glass: the bottle leads, the
       eyebrow and headline follow it up. */
    var ARR = [0.15, 0.92], ARR_T = [0.35, 0.80];
    var ROT_S = ASM_E;              /* turn begins once the bottle is solid */
    var ROT_E = B[4][0];            /* home as the finale lands */
    /* ...and disintegrates back out, the entrance reversed — as the desktop
       turntable does at DIS_S/DIS_E. Derived from the finale beat so the bottle is
       still whole while "That's the entire recipe" is read, and gone by the time
       the scene releases. */
    var DIS_S = B[4][0] + 0.060, DIS_E = B[4][1] - 0.020;

    /* Build the masked risers, exactly as the desktop engine does: every child of
       an ingredient beat clips, and its content moves into a wrapper that travels
       up from 100%. Non-ingredient beats (the lead and the finale) are left alone
       — desktop fades and lifts those as whole blocks instead. */
    var risers = [], isBody = [], isItem = [];
    beats.forEach(function (b) {
      var item = !!b.querySelector('.ximo-n');
      isItem.push(item);
      if (!item) { risers.push(null); isBody.push(null); return; }
      var rs = [], bd = [];
      [].slice.call(b.children).forEach(function (kid) {
        kid.style.overflow = 'hidden';
        bd.push(/ximo-d(\s|$)/.test(kid.className || ''));
        kid.innerHTML = '<span class="ximo-rise">' + kid.innerHTML + '</span>';
        rs.push(kid.firstChild);
      });
      risers.push(rs); isBody.push(bd);
    });

    /* Clearance under the floating pill, measured rather than assumed — it is two
       rows when its menu is open and one when not, and a value read once at load
       is stale from the moment that changes. Re-read every frame, applied only on
       change so it costs nothing. */
    var lastClr = -1;
    function clearance() {
      var p = document.getElementById('vab-anav'), c = 0;
      if (p) { var r = p.getBoundingClientRect(); if (r.height > 4) c = r.bottom; }
      if (!(c > 0)) c = 176;
      c = Math.round(c + 26);
      if (c === lastClr) return false;
      lastClr = c; (LEAD ? pin : run).style.setProperty('--ximo-clear', c + 'px'); return true;
    }

    /* The copy column claims only the height its tallest beat needs — measured in
       one pass with the beats briefly in flow. Anything else either guesses, or
       lets the column reflow on every beat change and shunt the bottle around. */
    function sizeBeats() {
      if (!beatsBox) return;
      beatsBox.style.height = '';
      beatsBox.classList.add('ximo-measuring');
      var tall = 0;
      for (var i = 0; i < beats.length; i++) tall = Math.max(tall, beats[i].offsetHeight);
      beatsBox.classList.remove('ximo-measuring');
      if (tall > 0) beatsBox.style.height = Math.ceil(tall) + 'px';
    }

    var noise = null, canDis = true;
    function fit() {
      clearance(); sizeBeats();
      if (!zone) return;
      var zs = getComputedStyle(zone);
      var availH = zone.clientHeight - parseFloat(zs.paddingTop || 0) - parseFloat(zs.paddingBottom || 0);
      var availW = Math.min(zone.clientWidth * 0.94, window.innerWidth * 0.82);
      /* Cap the bottle rather than letting it fill the zone: 38% of the stage keeps
         it clearly the hero while leaving air above and below inside its own 75%.
         Filling the zone is what made it read oversized. */
      availH = Math.min(availH, (pin.offsetHeight || window.innerHeight) * 0.38);
      if (!(availH > 0)) return;
      var h = availH, w = h * AR;
      if (w > availW) { w = availW; h = w / AR; }   /* never distort: one axis yields */
      cv.style.width = Math.round(w) + 'px';
      cv.style.height = Math.round(h) + 'px';
      cv.width = Math.max(1, Math.round(w * dpr));
      cv.height = Math.max(1, Math.round(h * dpr));
      /* Rebuilt with the canvas: the scatter thresholds are per-pixel, so they must
         match the new buffer or the grain would resample and crawl. */
      if (canDis) { noise = new Float32Array(cv.width * cv.height); for (var i = 0; i < noise.length; i++) noise[i] = Math.random(); }
    }

    function tile(i) { i = ((i % N) + N) % N; var k = i < UNIQ ? i : (2 * UNIQ - 1 - i); return [(k % COLS) * FW, Math.floor(k / COLS) * FH]; }

    var last = 0, lastAsm = 0, lastApr = 0, seam = false, ticking = false, pinState = '', lastBoxH = -1;
    function draw(p, asm) {
      if (asm == null) asm = cl((p - ASM_S) / (ASM_E - ASM_S));
      if (!ready) return;
      var rp = cl((p - ROT_S) / (ROT_E - ROT_S));
      var t = tile((F0 + Math.round(rp * N)) % N);  /* snap to whole frames — no
                                                       cross-fade, or the label
                                                       double-strikes and blurs */
      /* One scatter level for both ends: 1 = dispersed, 0 = solid. Whichever of the
         two is further from solid wins, so the bottle assembles in and disperses
         out through the identical code path — the exit is the entrance reversed. */
      var T = Math.max(1 - asm, cl((p - DIS_S) / (DIS_E - DIS_S)));
      ctx.clearRect(0, 0, cv.width, cv.height);
      if (T >= 1) return;
      /* CLEAN ENTRANCE AND EXIT (2026-10-01). The per-pixel noise scatter made the
         bottle arrive as a frosted, grainy copy of itself - it read as a low-res
         image loading, and it spoke a different particle language from the bean's
         sand. The bottle now simply rises into place as it comes up the screen
         (fading in over the last 24px of travel) and lifts away the same way. */
      var tin = 1 - asm, tex = cl((p - DIS_S) / (DIS_E - DIS_S));
      var sIn = tin * tin * (3 - 2 * tin), sEx = tex * tex * (3 - 2 * tex);
      ctx.globalAlpha = (1 - sIn) * (1 - sEx);
      ctx.drawImage(img, t[0], t[1], FW, FH, 0, 0, cv.width, cv.height);
      var oy = ((sIn * 0.10 - sEx * 0.07) * (cv.clientHeight || 0)).toFixed(1);
      if (cv.__oy !== oy) { cv.__oy = oy; cv.style.transform = 'translate3d(0,' + oy + 'px,0)'; }
      ctx.globalAlpha = 1;
      if (false) {
        try {
          var d = ctx.getImageData(0, 0, cv.width, cv.height), dt = d.data, W = cv.width, H = cv.height, band = 0.14;
          for (var i = 0, q = 0; q < dt.length; i++, q += 4) {
            if (dt[q + 3] === 0) continue;
            var n = noise[i] + 0.12 * (((i / W) | 0) / H - 0.5);
            if (n < T) dt[q + 3] = 0;
            else if (n < T + band) dt[q + 3] = dt[q + 3] * (n - T) / band;
          }
          ctx.putImageData(d, 0, 0);
        } catch (e) { canDis = false; }
      }
    }

    /* Beat animation, lifted from the desktop engine rather than reinvented.
       Ingredient beats: each line rises out of its own mask, the body delayed by
       .16 and the rest staggered by .03, then the whole block fades and lifts 14px
       on the way out. Lead and finale: fade and rise 22px in, fade and lift 18px
       out. Anchor: in across the first 5% of the scene, out across the last 9%. */
    function copy(p, aIn) {
      /* The anchor's floor is whichever of the approach and the pinned ramp is
         further on — Math.max, so it cannot step backwards at the lock, where the
         approach reads 1 and the pinned ramp restarts from 0. The exit multiplier
         stays untouched. */
      var av = Math.min(Math.max(aIn || 0, cl(p / 0.05)), 1 - cl((p - 0.90) / 0.09));
      for (var a = 0; a < anchor.length; a++) anchor[a].style.opacity = av.toFixed(3);
      for (var i = 0; i < beats.length; i++) {
        var lp = cl((p - B[i][0]) / (B[i][1] - B[i][0])), sl = beats[i];
        if (isItem[i]) {
          if (lp <= 0) { if (sl.style.opacity !== '0') sl.style.opacity = '0'; continue; }
          var eo = eIn(cl((lp - 0.72) / 0.28));
          sl.style.opacity = (1 - eo).toFixed(3);
          sl.style.transform = 'translateY(' + (-eo * 14).toFixed(1) + 'px)';
          var rs = risers[i], bd = isBody[i];
          for (var j = 0; j < rs.length; j++) {
            var din = bd[j] ? 0.16 : (j * 0.03);
            var cin = eOut(cl((lp - din) / 0.34));
            rs[j].style.transform = 'translateY(' + ((1 - cin) * 100).toFixed(2) + '%)';
          }
        } else {
          var inn = cl(lp / 0.26), out = cl((lp - 0.74) / 0.26);
          sl.style.opacity = Math.min(inn, 1 - out).toFixed(3);
          sl.style.transform = 'translateY(' + ((1 - inn) * 22 - out * 18).toFixed(1) + 'px)';
        }
      }
    }

    function render() {
      ticking = false;
      var r = geo.getBoundingClientRect(), vh = pin.offsetHeight || window.innerHeight;
      /* LOCK 1: same formula as before, against the lead the chapter now occupies
         at the top of the Tasting Notes section instead of against #ximo. */
      var tot = (LEAD ? LEAD.px() : run.offsetHeight) - vh;
      var p = tot > 0 ? cl(-r.top / tot) : 0;
      /* Pin by hand. State is read from the rect every frame rather than latched on
         a threshold crossing — landing mid-scene on a reload, or an iOS rubber-band
         overscroll, both skip the crossing and would strand the stage. */
      var want = (r.top > 0) ? '' : ((tot > 0 && -r.top >= tot) ? 'is-end' : 'is-fixed');
      if (want !== pinState) {
        /* LOCK 1: the Tasting Notes pin holds this stage now; no pin of its own. */
        if (!LEAD) {
          pin.classList.remove('is-fixed', 'is-end');
          if (want) pin.classList.add(want);
        }
        pinState = want;
      }
      /* Re-lay on either input that changes the box: the pill growing a second row,
         or the stage itself extending as the URL bar collapses. The canvas is sized
         from the zone, so it has to be re-fitted when the zone changes. */
      var boxH = pin.offsetHeight;
      if (clearance() || boxH !== lastBoxH) { lastBoxH = boxH; fit(); }
      /* apr: 0 as the section's top edge enters the bottom of the viewport, 1 at
         pin-lock, clamped past it. This is the only new measurement in the frame —
         r is already read above for the pin state. */
      var apr = cl(1 - r.top / vh);
      /* Math.max on both, so the lock is a continuous point: the approach term is
         already 1 there and the pinned term takes over as it overtakes it. Without
         the max the scene would re-scatter and re-fade the instant it pinned. */
      var asm = Math.max(cl((apr - ARR[0]) / (ARR[1] - ARR[0])),
                         cl((p - ASM_S) / (ASM_E - ASM_S)));
      var aIn = Math.max(cl((apr - ARR_T[0]) / (ARR_T[1] - ARR_T[0])), cl(p / 0.05));
      last = p; lastAsm = asm; lastApr = aIn;
      draw(p, asm);
      copy(p, aIn);
      var s = p > 0.012 && (!LEAD || p < 0.985);   /* LOCK 1: the hairline leaves with the chapter */
      if (s !== seam) { (LEAD ? pin : run).classList.toggle('seam-on', s); seam = s; }
    }
    function onScroll() { if (!ticking) { ticking = true; requestAnimationFrame(render); } }
    /* Width-only resize guard: iOS fires resize when the URL bar collapses, and
       re-fitting on that causes a visible jump mid-scroll. */
    var lastW = window.innerWidth;
    window.addEventListener('resize', function () {
      if (window.innerWidth === lastW) return;
      lastW = window.innerWidth; fit(); draw(last, lastAsm); copy(last, lastApr);
    }, { passive: true });
    window.addEventListener('scroll', onScroll, { passive: true });
    fit(); render();
  } catch (e) {}
})();